"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BondStatus = void 0;
var BondStatus;
(function (BondStatus) {
    BondStatus["Unbonded"] = "Unbonded";
    BondStatus["Unbonding"] = "Unbonding";
    BondStatus["Bonded"] = "Bonded";
    BondStatus["Unspecified"] = "Unspecified";
})(BondStatus = exports.BondStatus || (exports.BondStatus = {}));
//# sourceMappingURL=types.js.map